import React from "react";
import { useSelector } from "react-redux";
import EditTimeTable from "../TimeTable";
import { useContract } from "./Hook";

const SelectSans = ({ form, setform, item_id, reserve = false,isApp,contractPage }) => {
  const {
    user: { item },
  } = useSelector(state => state);
  const { toggleSelect, isInArray, selected } = useContract(
    form,
    setform,
    reserve
  );
  return (
    <div>
      <EditTimeTable
        id={item_id || item[0].id}
        contract={{
          status: true,
          toggleSelect,
          isInArray,
        }}
        isApp={isApp}
        contractPage={contractPage}
      />
    </div>
  );
};

export default SelectSans;
